import React from 'react';

export const Unknown = React.memo((props) => {
  return (
    <div className="flex items-center justify-center p-4 bg-amber-100 rounded text-xs text-amber-600">
      未支持的参数类型：{props.type}
    </div>
  );
});
